import { Fragment, useCallback, useState } from 'react';
import type { ChangeEventHandler, FC } from 'react';

import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import type { Unpacked } from '../../../../utils/types';

import * as styles from './AgeButtons.module.scss';

const AVAILABLE_AGE_LIMITS = [6, 9, 12, 15, 18] as const;

type AgeLimit = Unpacked<typeof AVAILABLE_AGE_LIMITS>;

interface AgeButtonsProps {
  onAgeButtonClick: (ageLimit: AgeLimit) => void;
}

const AgeButtons: FC<AgeButtonsProps> = ({ onAgeButtonClick }) => {
  const { t } = useTranslation();
  const [selectedAgeLimit, setAgeLimit] = useState<AgeLimit>();

  const onAgeLimitChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (event) => {
      const newAgeLimit = Number(event.target.value) as AgeLimit;

      setAgeLimit(newAgeLimit);
      onAgeButtonClick(newAgeLimit);
    },
    [onAgeButtonClick]
  );

  return (
    <Fragment>
      <div className={styles.label}>{t('select age limit')}</div>
      <div className={styles.ageLimitPicker}>
        {AVAILABLE_AGE_LIMITS.map((ageLimit) => {
          const isChecked = ageLimit === selectedAgeLimit;
          const radioClassName = classNames(styles.ageLimitRadio, {
            [styles.isChecked]: isChecked,
          });

          return (
            <label key={ageLimit} className={radioClassName}>
              <input
                className={styles.ageLimitInput}
                type="radio"
                name="ageLimit"
                value={ageLimit}
                checked={isChecked}
                onChange={onAgeLimitChange}
              />
              {ageLimit}
            </label>
          );
        })}
      </div>
    </Fragment>
  );
};

export { AgeButtons };
